import React, { memo } from 'react';
import { func, bool } from 'prop-types';
import { FormControlLabel, Switch } from '@material-ui/core';

import useStyles from './useStyles';

const ThemedSwitch = ({
  onChange,
  onClick,
  checked = false,
  disabled = false,
  labelPlacement = 'end',
  label = '',
}) => {
  const themed = useStyles();

  const control = (
    <Switch
      disabled={disabled}
      onChange={onChange}
      onClick={onClick}
      checked={checked}
      disableRipple
      disableFocusRipple
      classes={{
        root: themed.root,
        checked: themed.checked,
        switchBase: themed.switchBase,
        track: themed.track,
        thumb: themed.thumb,
        disabled: themed.disabled,
      }}
    />
  );

  return (
    <FormControlLabel
      labelPlacement={labelPlacement}
      control={control}
      label={label}
      classes={{ label: themed.label }}
    />
  );
};

ThemedSwitch.propTypes = {
  onChange: func,
  onClick: func,
  checked: bool,
  disabled: bool,
};

export default memo(ThemedSwitch);
